module.exports = __webpack_public_path__ + "fonts/StagSans-Thin.otf";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/StagSans-Thin.otf
// module id = 1082
// module chunks = 0